import { render, staticRenderFns } from "./study-bridge.vue?vue&type=template&id=1899a334&scoped=true&"
import script from "./study-bridge.vue?vue&type=script&lang=js&"
export * from "./study-bridge.vue?vue&type=script&lang=js&"
import style0 from "./study-bridge.vue?vue&type=style&index=0&id=1899a334&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899a334",
  null
  
)

export default component.exports